var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-actions',{staticClass:"pt-0"},[_c('div',[_c('core-ownerships',{attrs:{"value":{
        createdBy: _vm.rfq.createdBy,
        createdByEmail: _vm.rfq.createdByEmail,
        createdAt: _vm.rfq.createdAt,
      }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }